import { useState, useEffect } from "react";
import { db, auth } from "../firebase";
import { collection, addDoc, getDocs, query, orderBy, doc, updateDoc, increment } from "firebase/firestore";

const CATEGORIES = [
    "General",
    "Technical Help",
    "Advice",
    "Resources",
    "Networking",
    "Mentorship",
    "Other"
];

// Styles
const styles = {
    container: {
        maxWidth: "1200px",
        margin: "0 auto",
        background: "linear-gradient(135deg, #0f172a 0%, #1e293b 100%)",
        borderRadius: "20px",
        padding: "40px",
        color: "#f1f5f9",
        minHeight: "100vh",
    },
    title: {
        fontSize: "3rem",
        textAlign: "center",
        marginBottom: "12px",
        background: "linear-gradient(135deg, #06b6d4, #0ea5e9)",
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        fontWeight: "700",
    },
    subtitle: {
        textAlign: "center",
        color: "#cbd5e1",
        marginBottom: "40px",
        fontSize: "1.1rem",
    },
    tabs: {
        display: "flex",
        gap: "12px",
        marginBottom: "40px",
        borderBottom: "2px solid #334155",
        flexWrap: "wrap",
    },
    tabButton: {
        padding: "14px 28px",
        background: "transparent",
        color: "#94a3b8",
        border: "none",
        borderBottom: "3px solid transparent",
        cursor: "pointer",
        fontSize: "1rem",
        fontWeight: "600",
        transition: "all 0.3s ease",
    },
    tabButtonActive: {
        color: "#06b6d4",
        borderBottomColor: "#06b6d4",
    },
    formContainer: {
        background: "rgba(15, 23, 42, 0.8)",
        border: "1px solid #334155",
        borderRadius: "16px",
        padding: "32px",
        backdropFilter: "blur(10px)",
    },
    formTitle: {
        fontSize: "1.8rem",
        color: "#f1f5f9",
        marginBottom: "24px",
    },
    form: {
        display: "grid",
        gap: "24px",
    },
    formGroup: {
        display: "flex",
        flexDirection: "column",
        gap: "8px",
    },
    label: {
        color: "#cbd5e1",
        fontWeight: "600",
        fontSize: "0.95rem",
    },
    select: {
        padding: "12px 16px",
        background: "#1e293b",
        color: "#f1f5f9",
        border: "2px solid #475569",
        borderRadius: "10px",
        fontSize: "1rem",
        fontFamily: "inherit",
        transition: "all 0.3s ease",
        cursor: "pointer",
    },
    selectFocus: {
        borderColor: "#06b6d4",
        boxShadow: "0 0 0 3px rgba(6, 182, 212, 0.2)",
    },
    input: {
        padding: "12px 16px",
        background: "#1e293b",
        color: "#f1f5f9",
        border: "2px solid #475569",
        borderRadius: "10px",
        fontSize: "1rem",
        fontFamily: "inherit",
        transition: "all 0.3s ease",
    },
    textarea: {
        padding: "12px 16px",
        background: "#1e293b",
        color: "#f1f5f9",
        border: "2px solid #475569",
        borderRadius: "10px",
        fontSize: "1rem",
        fontFamily: "inherit",
        resize: "vertical",
        transition: "all 0.3s ease",
    },
    submitBtn: {
        padding: "14px 28px",
        background: "linear-gradient(135deg, #0ea5e9, #06b6d4)",
        color: "white",
        border: "none",
        borderRadius: "10px",
        fontSize: "1.05rem",
        fontWeight: "700",
        cursor: "pointer",
        transition: "all 0.3s ease",
        alignSelf: "flex-start",
    },
    submitBtnHover: {
        background: "linear-gradient(135deg, #0891d9, #04a8c4)",
        transform: "translateY(-2px)",
        boxShadow: "0 8px 20px rgba(6, 182, 212, 0.4)",
    },
    browseContainer: {
        animation: "fadeIn 0.4s ease-in",
    },
    categoryFilter: {
        display: "flex",
        gap: "12px",
        marginBottom: "32px",
        flexWrap: "wrap",
    },
    categoryBtn: {
        padding: "10px 20px",
        background: "#1e293b",
        color: "#94a3b8",
        border: "2px solid #475569",
        borderRadius: "24px",
        cursor: "pointer",
        fontWeight: "600",
        fontSize: "0.95rem",
        transition: "all 0.3s ease",
    },
    categoryBtnActive: {
        background: "#06b6d4",
        color: "white",
        borderColor: "#0891d9",
    },
    messageStats: {
        display: "flex",
        gap: "24px",
        marginBottom: "32px",
        color: "#cbd5e1",
        fontWeight: "600",
    },
    messagesList: {
        display: "grid",
        gap: "20px",
    },
    messageCard: {
        background: "rgba(30, 41, 59, 0.6)",
        border: "2px solid #334155",
        borderRadius: "14px",
        padding: "24px",
        transition: "all 0.3s ease",
        cursor: "pointer",
    },
    messageCardHover: {
        borderColor: "#0ea5e9",
        boxShadow: "0 12px 32px rgba(6, 182, 212, 0.25)",
        transform: "translateY(-2px)",
    },
    messageCardQuestion: {
        borderLeftColor: "#0ea5e9",
        borderLeftWidth: "5px",
    },
    messageCardOffer: {
        borderLeftColor: "#10b981",
        borderLeftWidth: "5px",
    },
    messageHeader: {
        display: "flex",
        gap: "12px",
        marginBottom: "14px",
        flexWrap: "wrap",
        alignItems: "center",
    },
    messageBadge: {
        display: "inline-block",
        padding: "6px 14px",
        background: "rgba(6, 182, 212, 0.2)",
        color: "#06b6d4",
        borderRadius: "20px",
        fontSize: "0.85rem",
        fontWeight: "600",
    },
    messageBadgeOffer: {
        background: "rgba(16, 185, 129, 0.2)",
        color: "#10b981",
    },
    messageCategory: {
        fontSize: "0.85rem",
        color: "#94a3b8",
        background: "#0f172a",
        padding: "6px 14px",
        borderRadius: "8px",
    },
    messageTitle: {
        fontSize: "1.3rem",
        color: "#f1f5f9",
        marginBottom: "12px",
        fontWeight: "600",
    },
    messageDescription: {
        color: "#cbd5e1",
        marginBottom: "18px",
        lineHeight: "1.6",
    },
    messageFooter: {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        flexWrap: "wrap",
        gap: "14px",
        paddingTop: "16px",
        borderTop: "1px solid #334155",
    },
    messageAuthor: {
        color: "#94a3b8",
        fontSize: "0.9rem",
    },
    messageActions: {
        display: "flex",
        gap: "10px",
    },
    actionBtn: {
        padding: "8px 14px",
        background: "#1e293b",
        color: "#94a3b8",
        border: "1px solid #475569",
        borderRadius: "8px",
        cursor: "pointer",
        fontSize: "0.85rem",
        fontWeight: "600",
        transition: "all 0.3s ease",
    },
    actionBtnHover: {
        color: "#06b6d4",
        borderColor: "#0ea5e9",
        background: "rgba(6, 182, 212, 0.1)",
    },
    loading: {
        textAlign: "center",
        padding: "50px 20px",
        color: "#94a3b8",
        fontSize: "1.1rem",
    },
    noMessages: {
        textAlign: "center",
        padding: "50px 20px",
        color: "#94a3b8",
        fontSize: "1.1rem",
    },
    toast: {
        position: "fixed",
        top: "20px",
        right: "20px",
        padding: "16px 24px",
        borderRadius: "10px",
        zIndex: 1000,
        animation: "slideIn 0.3s ease",
        fontWeight: "600",
        fontSize: "0.95rem",
    },
    toastSuccess: {
        background: "linear-gradient(135deg, #10b981, #059669)",
        color: "white",
        boxShadow: "0 8px 20px rgba(16, 185, 129, 0.3)",
    },
    toastError: {
        background: "linear-gradient(135deg, #ef4444, #dc2626)",
        color: "white",
        boxShadow: "0 8px 20px rgba(239, 68, 68, 0.3)",
    },
    modalOverlay: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: "rgba(0, 0, 0, 0.7)",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        zIndex: 999,
        backdropFilter: "blur(4px)",
    },
    modal: {
        background: "#1e293b",
        border: "2px solid #334155",
        borderRadius: "16px",
        padding: "32px",
        maxWidth: "500px",
        width: "90%",
        boxShadow: "0 20px 60px rgba(0, 0, 0, 0.5)",
    },
    modalTitle: {
        fontSize: "1.5rem",
        color: "#f1f5f9",
        marginBottom: "20px",
        fontWeight: "600",
    },
    modalTextarea: {
        width: "100%",
        padding: "12px 16px",
        background: "#0f172a",
        color: "#f1f5f9",
        border: "2px solid #475569",
        borderRadius: "10px",
        fontSize: "1rem",
        fontFamily: "inherit",
        marginBottom: "20px",
        resize: "vertical",
        transition: "all 0.3s ease",
    },
    modalButtons: {
        display: "flex",
        gap: "12px",
        justifyContent: "flex-end",
    },
    modalBtn: {
        padding: "10px 20px",
        borderRadius: "8px",
        border: "none",
        cursor: "pointer",
        fontWeight: "600",
        transition: "all 0.3s ease",
        fontSize: "0.95rem",
    },
    modalBtnCancel: {
        background: "#334155",
        color: "#cbd5e1",
    },
    modalBtnSubmit: {
        background: "linear-gradient(135deg, #0ea5e9, #06b6d4)",
        color: "white",
    },
};

const TABS = {
    ASK: "ask",
    GIVE: "give",
    BROWSE: "browse"
};

export default function Discussions() {
    const [activeTab, setActiveTab] = useState(TABS.BROWSE);
    const [selectedCategory, setSelectedCategory] = useState("General");
    const [messages, setMessages] = useState([]);
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        category: "General"
    });
    const [loading, setLoading] = useState(false);
    const [hoveredMessage, setHoveredMessage] = useState(null);
    const [hoveredBtn, setHoveredBtn] = useState(null);
    const [toast, setToast] = useState(null);
    const [replyModal, setReplyModal] = useState({ open: false, messageId: null });
    const [replyText, setReplyText] = useState("");

    // Fetch messages from Firestore
    useEffect(() => {
        const fetchMessages = async () => {
            try {
                setLoading(true);
                const q = query(
                    collection(db, "community-chat"),
                    orderBy("timestamp", "desc")
                );
                const querySnapshot = await getDocs(q);
                const msgs = querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    ...doc.data()
                }));
                setMessages(msgs);
            } catch (error) {
                console.error("Error fetching messages:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchMessages();
    }, []);

    const handleSubmitQuestion = async (e) => {
        e.preventDefault();
        const user = auth.currentUser;
        if (!user || !formData.title.trim()) return;

        try {
            await addDoc(collection(db, "community-chat"), {
                type: "question",
                title: formData.title,
                description: formData.description,
                category: formData.category,
                userId: user.uid,
                userEmail: user.email,
                timestamp: new Date(),
                likes: 0,
                replies: 0
            });

            setFormData({ title: "", description: "", category: "General" });
            alert("Question posted successfully!");
            setActiveTab(TABS.BROWSE);
        } catch (error) {
            console.error("Error posting question:", error);
            alert("Error posting question");
        }
    };

    const handleSubmitOffer = async (e) => {
        e.preventDefault();
        const user = auth.currentUser;
        if (!user || !formData.title.trim()) return;

        try {
            await addDoc(collection(db, "community-chat"), {
                type: "offer",
                title: formData.title,
                description: formData.description,
                category: formData.category,
                userId: user.uid,
                userEmail: user.email,
                timestamp: new Date(),
                likes: 0
            });

            setFormData({ title: "", description: "", category: "General" });
            alert("Offer posted successfully!");
            setActiveTab(TABS.BROWSE);
        } catch (error) {
            console.error("Error posting offer:", error);
            alert("Error posting offer");
        }
    };

    const showToast = (message, type = "success") => {
        setToast({ message, type });
        setTimeout(() => setToast(null), 3000);
    };

    const handleLike = async (messageId) => {
        const user = auth.currentUser;
        if (!user) {
            showToast("Please sign in to like posts", "error");
            return;
        }

        try {
            const messageRef = doc(db, "community-chat", messageId);
            await updateDoc(messageRef, {
                likes: increment(1)
            });
            showToast("👍 Liked!");

            // Refresh messages
            const q = query(
                collection(db, "community-chat"),
                orderBy("timestamp", "desc")
            );
            const querySnapshot = await getDocs(q);
            const msgs = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setMessages(msgs);
        } catch (error) {
            console.error("Error liking message:", error);
            showToast("Error liking post", "error");
        }
    };

    const handleReplyClick = (messageId) => {
        const user = auth.currentUser;
        if (!user) {
            showToast("Please sign in to reply", "error");
            return;
        }
        setReplyModal({ open: true, messageId });
    };

    const handleReplySubmit = async (e) => {
        e.preventDefault();
        const user = auth.currentUser;
        if (!user || !replyText.trim()) return;

        try {
            await addDoc(collection(db, "community-chat-replies"), {
                parentMessageId: replyModal.messageId,
                text: replyText,
                userId: user.uid,
                userEmail: user.email,
                timestamp: new Date(),
                likes: 0
            });

            showToast("Reply posted! 💬");
            setReplyText("");
            setReplyModal({ open: false, messageId: null });

            // Refresh messages
            const q = query(
                collection(db, "community-chat"),
                orderBy("timestamp", "desc")
            );
            const querySnapshot = await getDocs(q);
            const msgs = querySnapshot.docs.map((doc) => ({
                id: doc.id,
                ...doc.data()
            }));
            setMessages(msgs);
        } catch (error) {
            console.error("Error posting reply:", error);
            showToast("Error posting reply", "error");
        }
    };

    const filteredMessages = selectedCategory === "All"
        ? messages
        : messages.filter((msg) => msg.category === selectedCategory);

    const questionCount = filteredMessages.filter((m) => m.type === "question").length;
    const offerCount = filteredMessages.filter((m) => m.type === "offer").length;

    return (
        <>
            <br></br>
            <div style={styles.container}>
                <h1 style={styles.title}>Community Hub</h1>
                <p style={styles.subtitle}>Ask questions, share expertise, and help each other</p>

                {/* Tab Navigation */}
                <div style={styles.tabs}>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === TABS.ASK ? styles.tabButtonActive : {})
                        }}
                        onClick={() => setActiveTab(TABS.ASK)}
                    >
                        ❓ Ask a Question
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === TABS.GIVE ? styles.tabButtonActive : {})
                        }}
                        onClick={() => setActiveTab(TABS.GIVE)}
                    >
                        ✋ Offer Help
                    </button>
                    <button
                        style={{
                            ...styles.tabButton,
                            ...(activeTab === TABS.BROWSE ? styles.tabButtonActive : {})
                        }}
                        onClick={() => setActiveTab(TABS.BROWSE)}
                    >
                        💬 Browse ({messages.length})
                    </button>
                </div>

                {/* Ask a Question Tab */}
                {activeTab === TABS.ASK && (
                    <div style={styles.formContainer}>
                        <h2 style={styles.formTitle}>Post a Question</h2>
                        <form onSubmit={handleSubmitQuestion} style={styles.form}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Category</label>
                                <select
                                    value={formData.category}
                                    onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                    style={styles.select}
                                >
                                    {CATEGORIES.map((cat) => (
                                        <option key={cat} value={cat}>{cat}</option>
                                    ))}
                                </select>
                            </div>

                            <div style={styles.formGroup}>
                                <label style={styles.label}>Question Title</label>
                                <input
                                    type="text"
                                    placeholder="What would you like to ask?"
                                    value={formData.title}
                                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                    style={styles.input}
                                    required
                                />
                            </div>

                            <div style={styles.formGroup}>
                                <label style={styles.label}>Details (Optional)</label>
                                <textarea
                                    placeholder="Provide more context about your question..."
                                    value={formData.description}
                                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                    style={styles.textarea}
                                    rows="6"
                                />
                            </div>

                            <button
                                type="submit"
                                style={{
                                    ...styles.submitBtn,
                                    ...(hoveredBtn === "ask" ? styles.submitBtnHover : {})
                                }}
                                onMouseEnter={() => setHoveredBtn("ask")}
                                onMouseLeave={() => setHoveredBtn(null)}
                            >
                                Post Question
                            </button>
                        </form>
                    </div>
                )}

                {/* Offer Help Tab */}
                {activeTab === TABS.GIVE && (
                    <div style={styles.formContainer}>
                        <h2 style={styles.formTitle}>Share Your Expertise</h2>
                        <form onSubmit={handleSubmitOffer} style={styles.form}>
                            <div style={styles.formGroup}>
                                <label style={styles.label}>Category</label>
                                <select
                                    value={formData.category}
                                    onChange={(e) => setFormData({ ...formData, category: e.target.value })}
                                    style={styles.select}
                                >
                                    {CATEGORIES.map((cat) => (
                                        <option key={cat} value={cat}>{cat}</option>
                                    ))}
                                </select>
                            </div>

                            <div style={styles.formGroup}>
                                <label style={styles.label}>What Can You Help With?</label>
                                <input
                                    type="text"
                                    placeholder="E.g., React debugging, Career advice, etc."
                                    value={formData.title}
                                    onChange={(e) => setFormData({ ...formData, title: e.target.value })}
                                    style={styles.input}
                                    required
                                />
                            </div>

                            <div style={styles.formGroup}>
                                <label style={styles.label}>Description</label>
                                <textarea
                                    placeholder="Tell others about your expertise and how they can reach out..."
                                    value={formData.description}
                                    onChange={(e) => setFormData({ ...formData, description: e.target.value })}
                                    style={styles.textarea}
                                    rows="6"
                                />
                            </div>

                            <button
                                type="submit"
                                style={{
                                    ...styles.submitBtn,
                                    ...(hoveredBtn === "offer" ? styles.submitBtnHover : {})
                                }}
                                onMouseEnter={() => setHoveredBtn("offer")}
                                onMouseLeave={() => setHoveredBtn(null)}
                            >
                                Post Your Offer
                            </button>
                        </form>
                    </div>
                )}

                {/* Browse Messages Tab */}
                {activeTab === TABS.BROWSE && (
                    <div style={styles.browseContainer}>
                        <div style={styles.categoryFilter}>
                            <button
                                style={{
                                    ...styles.categoryBtn,
                                    ...(selectedCategory === "All" ? styles.categoryBtnActive : {})
                                }}
                                onClick={() => setSelectedCategory("All")}
                            >
                                All ({messages.length})
                            </button>
                            {CATEGORIES.map((cat) => {
                                const count = messages.filter((m) => m.category === cat).length;
                                return (
                                    <button
                                        key={cat}
                                        style={{
                                            ...styles.categoryBtn,
                                            ...(selectedCategory === cat ? styles.categoryBtnActive : {})
                                        }}
                                        onClick={() => setSelectedCategory(cat)}
                                    >
                                        {cat} ({count})
                                    </button>
                                );
                            })}
                        </div>

                        <div style={styles.messageStats}>
                            <span>❓ Questions: {questionCount}</span>
                            <span>✋ Offers: {offerCount}</span>
                        </div>

                        {loading ? (
                            <p style={styles.loading}>Loading messages...</p>
                        ) : filteredMessages.length === 0 ? (
                            <p style={styles.noMessages}>No messages yet in this category. Be the first to post!</p>
                        ) : (
                            <div style={styles.messagesList}>
                                {filteredMessages.map((msg) => (
                                    <div
                                        key={msg.id}
                                        style={{
                                            ...styles.messageCard,
                                            ...(msg.type === "question" ? styles.messageCardQuestion : styles.messageCardOffer),
                                            ...(hoveredMessage === msg.id ? styles.messageCardHover : {})
                                        }}
                                        onMouseEnter={() => setHoveredMessage(msg.id)}
                                        onMouseLeave={() => setHoveredMessage(null)}
                                    >
                                        <div style={styles.messageHeader}>
                                            <span style={{
                                                ...styles.messageBadge,
                                                ...(msg.type === "offer" ? styles.messageBadgeOffer : {})
                                            }}>
                                                {msg.type === "question" ? "❓ Question" : "✋ Offer"}
                                            </span>
                                            <span style={styles.messageCategory}>{msg.category}</span>
                                        </div>
                                        <h3 style={styles.messageTitle}>{msg.title}</h3>
                                        {msg.description && (
                                            <p style={styles.messageDescription}>{msg.description}</p>
                                        )}
                                        <div style={styles.messageFooter}>
                                            <span style={styles.messageAuthor}>By {msg.userEmail}</span>
                                            <div style={styles.messageActions}>
                                                <button
                                                    style={{
                                                        ...styles.actionBtn,
                                                        ...(hoveredBtn === `like-${msg.id}` ? styles.actionBtnHover : {})
                                                    }}
                                                    onMouseEnter={() => setHoveredBtn(`like-${msg.id}`)}
                                                    onMouseLeave={() => setHoveredBtn(null)}
                                                    onClick={() => handleLike(msg.id)}
                                                >
                                                    👍 Like ({msg.likes || 0})
                                                </button>
                                                <button
                                                    style={{
                                                        ...styles.actionBtn,
                                                        ...(hoveredBtn === `reply-${msg.id}` ? styles.actionBtnHover : {})
                                                    }}
                                                    onMouseEnter={() => setHoveredBtn(`reply-${msg.id}`)}
                                                    onMouseLeave={() => setHoveredBtn(null)}
                                                    onClick={() => handleReplyClick(msg.id)}
                                                >
                                                    💬 Reply
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                )}

                {/* Toast Notification */}
                {toast && (
                    <div
                        style={{
                            ...styles.toast,
                            ...(toast.type === "success" ? styles.toastSuccess : styles.toastError),
                        }}
                    >
                        {toast.message}
                    </div>
                )}

                {/* Reply Modal */}
                {replyModal.open && (
                    <div style={styles.modalOverlay} onClick={() => setReplyModal({ open: false, messageId: null })}>
                        <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
                            <h2 style={styles.modalTitle}>Reply to Post</h2>
                            <form onSubmit={handleReplySubmit}>
                                <textarea
                                    placeholder="Share your thoughts..."
                                    value={replyText}
                                    onChange={(e) => setReplyText(e.target.value)}
                                    style={styles.modalTextarea}
                                    rows="5"
                                    required
                                />
                                <div style={styles.modalButtons}>
                                    <button
                                        type="button"
                                        style={{ ...styles.modalBtn, ...styles.modalBtnCancel }}
                                        onClick={() => setReplyModal({ open: false, messageId: null })}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="submit"
                                        style={{ ...styles.modalBtn, ...styles.modalBtnSubmit }}
                                    >
                                        Post Reply
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                )}
            </div>
        </>
    );
}
